
// import axios from 'axios';
import { get, post } from './tools';
import * as config from './config';
import React, { /* Component */ } from 'react'
// import axios from 'axios';
import intl from 'react-intl-universal';
// import { message } from 'antd';
// export const getBbcNews = () => get({ url: config.NEWS_BBC });

// export const npmDependencies = () =>
//     axios
//         .get('./npm.json')
//         .then(res => res.data)
//         .catch(err => console.log(err));

// export const weibo = () =>
//     axios
//         .get('./weibo.json')
//         .then(res => res.data)
//         .catch(err => console.log(err));

// export const gitOauthLogin = () =>
//     get({
//         url: `${config.GIT_OAUTH}/authorize?client_id=792cdcd244e98dcd2dee&redirect_uri=http://localhost:3006/&scope=user&state=reactAdmin`,
//     });
// export const gitOauthToken = (code) =>
//     post({
//         url: `https://cors-anywhere.herokuapp.com/${config.GIT_OAUTH}/access_token`,
//         data: {
//             client_id: '792cdcd244e98dcd2dee',
//             client_secret: '81c4ff9df390d482b7c8b214a55cf24bf1f53059',
//             redirect_uri: 'http://localhost:3006/',
//             state: 'reactAdmin',
//             code,
//         },
//     });
// // {headers: {Accept: 'application/json'}}
// export const gitOauthInfo = (access_token) =>
//     get({ url: `${config.GIT_USER}access_token=${access_token}` });

// // easy-mock data interaction
// // Admin permission fetch
// export const admin = () => get({ url: config.MOCK_AUTH_ADMIN });
// // Visitor permission fetch
// export const guest = () => get({ url: config.MOCK_AUTH_VISITOR });
// // export const GET_newspush = () => get({ url: config.GET_newspush });



export const getCategory = (params) => {
    const errorNetWork =(<span>
            <span>{intl.formatMessage({ id: 'error' })}</span><br/>
            <span>{intl.formatMessage({ id: 'netWorkError' })}</span>
        </span>
    )
    return get({ url: `${config.GET_category}`,msg:errorNetWork,config:{params:params,
    
}});
}
export const getTemplateList = (params) => {
    const errorNetWork =(<span>
        <span>{intl.formatMessage({ id: 'error' })}</span><br/>
        <span>{intl.formatMessage({ id: 'netWorkError' })}</span>
    </span>
)
    return get({ url: `${config.GET_templateList}`,msg:errorNetWork,config:{params:params,
      
}});
}
export const getTemplateUlists = (params) => {
     const errorNetWork =(<span>
            <span>{intl.formatMessage({ id: 'error' })}</span><br/>
            <span>{intl.formatMessage({ id: 'netWorkError' })}</span>
        </span>
    )
    const postConfig = {
      headers: {
          'Authorization': `Bearer ${params.access_token}`
      }
    }
    delete params.access_token
    return get({
        url: config.GET_templateUlists,
        msg:errorNetWork,
        config:{
          params,
          ...postConfig
        }
    });
}
export const getTemplateSearch = (params) => {
     const errorNetWork =(<span>
            <span>{intl.formatMessage({ id: 'error' })}</span><br/>
            <span>{intl.formatMessage({ id: 'netWorkError' })}</span>
        </span>
    )
    return get({ url: `${config.GET_templateSearch}`,msg:errorNetWork,config:{params:params,
      
}});
}
export const getTemplateDownload = (params) => {
      const errorNetWork =(<span>
            <span>{intl.formatMessage({ id: 'error' })}</span><br/>
            <span>{intl.formatMessage({ id: 'netWorkError' })}</span>
        </span>
    )
    return get({ url: `${config.GET_templateDownload}`,msg:errorNetWork,config:{params:params,
      
}});
}
export const postTemplateUse = (params) =>{
     const errorNetWork =(<span>
            <span>{intl.formatMessage({ id: 'error' })}</span><br/>
            <span>{intl.formatMessage({ id: 'netWorkError' })}</span>
        </span>
    )
    const postConfig = {
        headers: {
            'Authorization': `Bearer ${params.access_token}`
        }
    }
    delete params.access_token

    let  formData = new FormData();
    formData.append('template_id',params.template_id)
    return post({
        url: config.POST_templateUse,
        msg:errorNetWork,
        data:formData,
        config: postConfig
    });

}
export const getTemplateInfo = (params) => {
    const errorNetWork =(<span>
        <span>{intl.formatMessage({ id: 'error' })}</span><br/>
        <span>{intl.formatMessage({ id: 'netWorkError' })}</span>
    </span>
)
    return get({ url: `${config.GET_templateInfo}`,msg:errorNetWork,config:{params:params,
      
}});
}
export const getClicksRank = (params) => {
    const errorNetWork =(<span>
        <span>{intl.formatMessage({ id: 'error' })}</span><br/>
        <span>{intl.formatMessage({ id: 'netWorkError' })}</span>
    </span>
)
    return get({ url: `${config.GET_clicks_rank}`,msg:errorNetWork,config:{params:params,
      
}});
}
export const postComment = (params) =>{
    const errorNetWork =(<span>
           <span>{intl.formatMessage({ id: 'error' })}</span><br/>
           <span>{intl.formatMessage({ id: 'netWorkError' })}</span>
       </span>
   )
   const postConfig = {
       headers: {
          'Authorization': `Bearer ${ params.access_token }`
       }
   }
   delete params.access_token

   let  formData = new FormData();
   for (let key in params) {
       formData.append(key, params[key]);
   }
   return post({
       url: config.POST_comment,
       msg:errorNetWork,
       data:formData,
       config: postConfig
   });

}
export const PostTemplateClicks = (params) =>{
    const errorNetWork =(<span>
           <span>{intl.formatMessage({ id: 'error' })}</span><br/>
           <span>{intl.formatMessage({ id: 'netWorkError' })}</span>
       </span>
   )
   const postConfig = {
       headers: {
           'Authorization': `Bearer ${params.access_token}`
       }
   }
   delete params.access_token

   let formData = new FormData();
   for (let key in params) {
       formData.append(key, params[key]);
   }
   
   return post({
       url: config.POST_template_clicks,
       msg:errorNetWork,
       data:formData,
       config: postConfig
   });

}
